<template>
    <div class="md-cta-tc-sc standard" :style="{ marginBottom }">
        <div
            ref="content"
            class="cta-container"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :style="{ minHeight: minHeight }"
        >
            <site-img
                class="img-column"
                :style="{ order: imgLeft ? 0 : 1 }"
                :src="usePicture"
                type="bgImg"
            ></site-img>
            <site-img
                class="copy-column"
                :src="copyType === 'img' ? useCopyPicture : ''"
                :style="{
                    backgroundColor:
                        copyType === 'color' ? copyBackgroundColor : ''
                }"
                type="bgImg"
            >
                <div class="copy-content">
                    <div v-if="title" class="title" v-html="formatFontSize(title, 26)" style="font-family:var(--font-title)"></div>
                    <div v-if="desc" class="desc" v-html="formatFontSize(desc, 16)" style="font-family:var(--font-normal)"></div>
                    <banner-button
                        :style="{ justifyContent: buttonAlign }"
                        :buttons="buttons"
                        @callback="showRegisterPop"
                    ></banner-button>
                </div>
            </site-img>
        </div>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-cta-tc-sc.standard {
    .cta-container {
        display: flex;
    }
    .img-column {
        width: 50%;
    }
    .copy-column {
        width: 50%;
        display: flex;
        align-items: center;
        padding: 20px 6.25%;
        .copy-content {
            width: 100%;
            text-align: left;
            color: #fff;
            p {
                line-height: inherit;
                overflow: hidden;
            }
        }
        .title {
            font-size: 26px;
            line-height: 1.38;
            font-family: var(--font-title);
            @include webkitBox(3);
        }
        .desc {
            margin-top: 30px;
            font-size: 16px;
            line-height: 1.5;
            @include webkitBox(10);
        }
        .banner-button {
            width: calc(100% + 20px);
            margin: 60px -10px 0 -10px;
            font-size: 14px;
            .btn-item {
                font-family: var(--mg-button-font);
                margin: 0 10px;
                min-width: 100px;
                height: 50px;
                line-height: 50px;
                font-size: 1em;
                padding: 0 20px;
                border: none;
            }
        }
    }
    @include media-600 {
        .cta-container {
            padding: 0;
            flex-direction: column;
        }
        .img-column {
            width: 100%;
            height: 280px;
        }
        .copy-column {
            flex: 1;
            width: 100%;
            padding: 30px 15px;
            order: 2;
            .title {
                font-size: 16px;
                line-height: 1.25;
                letter-spacing: 3.84px;
            }
            .desc {
                margin-top: 20px;
                font-size: 14px;
                line-height: 1.43;
            }
            .banner-button {
                margin-top: 20px;
                .btn-item {
                    height: 40px;
                    line-height: 40px;
                }
            }
        }
    }
}
</style>
